export default "__VITE_ASSET__Bz6IOJs0__"